import { useState, useEffect } from "react";
import app from "nystem";
import { Wrapper } from "nystem-components";

const ViewTextEventVal = ({ model, view, path }) => {
  const [value, setValue] = useState();

  useEffect(() => {
    const getValue = (value, path) =>
      path
        ? path.split(".").reduce((val, key) => val && val[key], value)
        : value;

    const checkActive = (query) => {
      if (query.type !== model.event) return;
      setValue(getValue(query, model.field));
    };
    app.connection.on("emit", checkActive);
    return () => {
      app.connection.off(model.event, -10, checkActive);
    };
  }, [model, view]);

  if (!value) return null;

  return <Wrapper className={model.className}>{app.t(value)}</Wrapper>;
};
export default ViewTextEventVal;
